'use es6';

export const sumCount = 'SUM|count';
export const TABLE_COLUMNS_FOR_DIMENSION = ['PUSHED', 'NOT_PUSHED'];